module.exports = __webpack_public_path__ + "static/media/kr.6d3d963f.svg";